import { combineReducers } from 'redux';
import { userReducer } from "./userReducer";
import { groupReducer } from "./groupReducer";

export const reducers = combineReducers({
    userReducer, groupReducer
});
